import styled, { css } from 'styled-components'

// Utils
import { breakpoint } from '@sketch/global-styles'

// Types
import { ColumnProps } from './Grid.types'

export const Container = styled.div<ColumnProps>`
  ${props =>
    css`
      grid-column: auto / span ${props?.xs || 12};
      --grid-columns: ${props?.xs || 12};

      ${breakpoint('sm')`
        grid-column: auto / span ${props?.sm};
        --grid-columns: ${props?.sm};
    `}

      ${breakpoint('md')`
        grid-column: auto / span ${props?.md};
        --grid-columns: ${props?.md};
    `}
    
    ${breakpoint('lg')`
        grid-column: auto / span ${props?.lg};
        --grid-columns: ${props?.lg};
    `}

    ${breakpoint('xl')`
        grid-column: auto / span ${props?.xl};
        --grid-columns: ${props?.xl};
    `}
    `};
`
